import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { SharedChartsModule } from '@shared/charts';

@Component({
  selector: 'la-upgrade-indicator',
  imports: [CommonModule, MatIconModule, SharedChartsModule],
  templateUrl: './upgrade-indicator.component.html',
  styleUrl: './upgrade-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeIndicatorComponent {
  @Input() value!: number;
  @Input() max!: number;
  @Input() item!: string;
  @Input() hideUpgrade = false;

  @Output() action = new EventEmitter<void>();

  router = inject(Router);

  click() {
    if (this.hideUpgrade) {
      return;
    }

    this.router.navigate(['/account/subscription/upgrade']);
    this.action.emit();
  }
}
